import React from "react";
import BookingButtonBuilderTabContent from "./BookingButtonBuilderTabContent";
import Tabs from '../Tabs/Tabs';
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import ModalButtons from "../ModalButtons/ModalButtons";
import Errors from "../Errors/Errors";

class BookingButtonBuilder extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      active_tab: 'general',
      loading: false,
      errors: null,
			success: null,
			link_color: this.props.link_color,
      widget_default_color: this.props.widget_default_color,
			button_background_color: this.props.button_background_color,
      button_font_color: this.props.button_font_color,
			position: this.props.position,
			read_only: this.props.read_only,
			rounded_corners: this.props.rounded_corners,
			size: this.props.size,
			style: this.props.style,
			text: this.props.text,
			visible: this.props.visible,
      daily_rentals_menu_visible: this.props.daily_rentals_menu_visible,
      daily_rentals_menu_label: this.props.daily_rentals_menu_label,
      products_menu_visible: this.props.products_menu_visible,
      products_menu_label: this.props.products_menu_label,
      vouchers_menu_visible: this.props.vouchers_menu_visible,
      vouchers_menu_label: this.props.vouchers_menu_label,
			session_timeout_enabled: this.props.session_timeout_enabled,
			session_timeout_duration: this.props.session_timeout_duration,
      session_grace_period: this.props.session_grace_period,
      session_timeout_warning_text: this.props.session_timeout_warning_text,
      session_timeout_confirmation_text: this.props.session_timeout_confirmation_text,
      forms: this.props.forms || [],
      all_room_types: this.props.all_room_types || [],
      all_order_forms: this.props.all_order_forms || [],
      order: [],
      roomTypeOrder:[],
      form: this.props.form || '',
      no_availability_text: this.props.no_availability_text,
    }

    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.onChange = this.onChange.bind(this)
    this.onFieldChange = this.onFieldChange.bind(this)
    this.onChangeSessionTimeoutEnabled = this.onChangeSessionTimeoutEnabled.bind(this)
    this.onChangeForms = this.onChangeForms.bind(this)
    this.onChangeForm = this.onChangeForm.bind(this)
    this.onChangeOrder = this.onChangeOrder.bind(this)
    this.onChangeRoomTypeOrder = this.onChangeRoomTypeOrder.bind(this)
  }

  render() {
    var self = this;
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: function (e) {
          self.onSave();
          return false;
        },
      },
    ]

    return (
      <div className="dates-and-times-builder">
        <Errors errors={this.state.errors ? [I18n.t('there_were_errors')] : null} /> 
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          <BookingButtonBuilderTabContent 
            {...this.state}
            onChange={this.onChange}
            onFieldChange={this.onFieldChange}
            onChangeSessionTimeoutEnabled={this.onChangeSessionTimeoutEnabled}
            onChangeForms={this.onChangeForms}
            onChangeForm={this.onChangeForm}
            onChangeOrder={this.onChangeOrder}
            onChangeRoomTypeOrder={this.onChangeRoomTypeOrder}
          />
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }

  tabs() {
    return(
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          tabErrorCount: this.state.errors ? Object.keys(this.state.errors).length : 0,
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('session_timeout'),
          targetName: 'session_timeout',
          classes: this.state.active_tab === 'session_timeout' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('menu'),
          targetName: 'menu',
          classes: this.state.active_tab === 'menu' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('form'),
          targetName: 'form',
          classes: this.state.active_tab === 'form' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('room_type_order'),
          targetName: 'room_type_order',
          classes: this.state.active_tab === 'room_type_order' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('no_availability'),
          targetName: 'no_availability',
          classes: this.state.active_tab === 'no_availability' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
      ]
    )
  }

  onChangeActiveTab(active_tab) {
    this.setState({
      active_tab: active_tab
    });
  };

  onChange(name, value) {

    
		var state = this.state;
		state[name] = value;

		this.setState(state);
	}

	onFieldChange(event){
    if (event && event.target) {
      this.setState({
        [event.target.id]: event.target.value
      });
    }
  }

  onChangeForms(event) {
    if (event && event.target) {
      this.setState({forms: event.target.value})
    }
  }
  onChangeForm(form) {
    if(form && form.id != form.text) {
      var formID = form.id
      this.setState({form: formID})
    } else {
      this.setState({form: ''})
    }
  }

	onChangeSessionTimeoutEnabled(e) {
		if(e.target.value === "enabled") {
			this.setState({session_timeout_enabled: true})
		} else {
			this.setState({session_timeout_enabled: false})
		}
  }

  onChangeOrder(idsInOrder) {
    this.setState({order:idsInOrder})
  }

  onChangeRoomTypeOrder(idsInOrder) {
    this.setState({roomTypeOrder:idsInOrder})
  }

  onSave() {
    this.setState({loading: true});
    
    $.ajax({
      type: 'POST',
      url: '/admin/booking_button_appearance/update',
      data: {
        booking_button: {
          link_color: this.state.link_color,
          widget_default_color: this.state.widget_default_color,
          button_background_color: this.state.button_background_color,
          button_font_color: this.state.button_font_color,
          position: this.state.position,
          rounded_corners: this.state.rounded_corners,
          size: this.state.size,
          style: this.state.style,
          text: this.state.text,
          visible: this.state.visible,
          products_menu_visible: this.state.products_menu_visible,
          products_menu_label: this.state.products_menu_label,
          vouchers_menu_visible: this.state.vouchers_menu_visible,
          vouchers_menu_label: this.state.vouchers_menu_label,
          daily_rentals_menu_label: this.state.daily_rentals_menu_label,
          daily_rentals_menu_visible: this.state.daily_rentals_menu_visible,
          order_form_ids: [ this.state.form ],
          form_ids: [ this.state.form ]
        },
        session_timeout: {
          session_timeout_enabled: this.state.session_timeout_enabled,
          session_timeout_duration: this.state.session_timeout_duration,
          session_grace_period: this.state.session_grace_period,
          session_timeout_warning_text: this.state.session_timeout_warning_text,
          session_timeout_confirmation_text: this.state.session_timeout_confirmation_text
        },
        reservation_setting: {
          no_availability_text: this.state.no_availability_text
        },
        room_types: this.state.roomTypeOrder.reduce((map, id, idx) => { map[id] = {position: idx}; return map}, {})
      }
    }).done((data) => {
      if (data.success) {
        window.parent.$(window.parent).trigger('bookingButtonSaved', data)
        this.setState({loading: false, errors: null});
        if (parent && parent.refresh_data) {
          parent.refresh_data(I18n.t('booking_button_did_save_successfully'));
        }
        if (parent && parent.hide_modal) {
          parent.hide_modal();
        }
      } else {
        this.setState({loading: false, errors: data.errors});
      }
    })
  }
};

export default BookingButtonBuilder
